import React from 'react'
import { Routes, Route, useNavigate } from 'react-router-dom'

import PageLoader from 'Layout/PageLoader'

import { useGetAppQuery } from './happyfox-helpdesk.service'
import InstallHappyFoxHelpdesk from './InstallHappyFoxHelpdesk'
import ManageHappyFoxHelpdesk from './ManageHappyFoxHelpdesk'
import HelpDeskAuthenticateForm from './HelpDeskAuthenticateForm'

const HappyFoxHelpdesk = () => {
  const { isLoading, isError, error, data: helpdesk = {} } = useGetAppQuery()
  const navigate = useNavigate()

  if (isLoading) {
    return <PageLoader />
  }

  const handleAuthFormCancel = () => {
    navigate('./')
  }

  if ((isError && error.status === 404) || !helpdesk.is_active) {
    return <InstallHappyFoxHelpdesk onCancel={handleAuthFormCancel} />
  }

  return (
    <Routes>
      <Route
        path='auth'
        element={<HelpDeskAuthenticateForm onCancel={handleAuthFormCancel} onAuth={handleAuthFormCancel} />}
      />
      <Route path='*' element={<ManageHappyFoxHelpdesk {...helpdesk} />} />
    </Routes>
  )
}

export default HappyFoxHelpdesk
